<template>
    <div>
        <header-component></header-component>
        <div class="main dashboard">
            <router-view/>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
import Vue from 'vue'
import { store } from '@/app/store'

export default {
  name: 'HomeComponent',
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/users/current'
      }),
      Vue.axios({
        method: 'get',
        url: '/notifications/unread'
      })
    ])
    .then(Vue.axios.spread((userResponse, notificationReponse) => {
      store.dispatch('setUser', userResponse.data.data.user)
      store.dispatch('setNotification', {
        count: notificationReponse.data.data.unread_count
      })

      if( !store.state.user.address_id )
        next('/adres')

      next()
    }))
    .catch(error => next(false))
  },
  watch:{
      $route (to, from){
          if( !store.state.user.address_id )
            this.$router.push('/adres')
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/HomeComponent.vue